import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Users } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, EmptyState } from "@/components/ranger/PageHeader";
import { ConfirmButton } from "@/components/ranger/ConfirmButton";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, fmtTime } from "@/lib/api";

export const PlayerRecords = ({ cid }) => {
  const { can } = useAuth();
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get(`/communities/${cid}/player-records`).then((r) => setRows(r.data)).catch(() => {}), [cid]);
  useEffect(() => { load(); }, [load]);
  const del = async (id) => { try { await api.delete(`/communities/${cid}/player-records/${id}`); toast.success("Record deleted"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Card title="Player records" icon={Users} testId="player-records-card" className="mt-5">
      {rows.length === 0 ? <EmptyState title="No records yet" testId="player-records-empty">Players are recorded when seen online or when they link.</EmptyState> : (
        <div className="overflow-x-auto">
          <Table data-testid="player-records-table">
            <TableHeader><TableRow className="border-[#1E2D4A]">{["Gamertag", "Discord", "Balance", "Warnings", "First seen", "Last seen", ""].map((h) => <TableHead key={h} className="rg-label whitespace-nowrap">{h}</TableHead>)}</TableRow></TableHeader>
            <TableBody>{rows.map((r) => (
              <TableRow key={r.id} data-testid={`player-record-${r.id}`} className="border-[#1E2D4A]/60 text-xs">
                <TableCell className="font-display text-base font-semibold text-slate-100">{r.gamertag}</TableCell>
                <TableCell className="text-slate-300">{r.discord_username || <span className="text-slate-500">Not linked</span>}</TableCell>
                <TableCell className="font-mono text-slate-300">{r.balance ?? "—"}</TableCell>
                <TableCell className={`font-mono ${r.warnings ? "text-amber-400" : "text-slate-500"}`}>{r.warnings}</TableCell>
                <TableCell className="whitespace-nowrap text-slate-400">{fmtTime(r.first_seen)}</TableCell>
                <TableCell className="whitespace-nowrap text-slate-400">{fmtTime(r.last_seen)}</TableCell>
                <TableCell>{can("admin") && <ConfirmButton testId={`player-record-delete-${r.id}`} className="text-slate-300 hover:text-red-400" title="Delete record?" description="Removes the player record only. Links, wallet and warnings are kept." onConfirm={() => del(r.id)}><Trash2 className="h-4 w-4" /></ConfirmButton>}</TableCell>
              </TableRow>
            ))}</TableBody>
          </Table>
        </div>
      )}
    </Card>
  );
};
